import React from 'react';
import { Button } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { useUpdateRefundMutation } from '../../../../services/RefundService';
import { clearBackupAction as clearBackup } from '../../../../services/RefundService/slice';
import { useNavigate } from 'react-router-dom';

interface SubmitForApprovalButtonProps {
  onError?: (message: string) => void;
}

export const SubmitForApprovalButton: React.FC<SubmitForApprovalButtonProps> = ({ onError }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { currentRefund } = useAppSelector(state => state.refund);
  const [updateRefundMutation, { isLoading }] = useUpdateRefundMutation();

  const isVisible = currentRefund?.status === 'STARTED';

  if (!isVisible) return null;

  const handleSubmitForApproval = async () => {
    if (!currentRefund) return;

    const refundForApproval = {
      ...currentRefund,
      status: 'APPROVE'
    };

    try {
      await updateRefundMutation({ refundView: refundForApproval }).unwrap();
      dispatch(clearBackup());
      navigate(-1);
    } catch (err) {
      onError?.('Failed to submit for approval. Please try again.');
    }
  };

  return (
    <Button
      variant="contained"
      startIcon={<SendIcon />}
      onClick={handleSubmitForApproval}
      disabled={isLoading}
      sx={{
        backgroundColor: '#059669',
        '&:hover': {
          backgroundColor: '#047857',
        },
        fontWeight: 600
      }}
    >
      {isLoading ? 'Submitting...' : 'Submit for Approval'}
    </Button>
  );
};
